export default class LikedAd {
  constructor(firebaseId, data = {}) {
    this.firebaseId = firebaseId;
    this.newarcHomeId = data.newarcHomeId || '';
    this.userId = data.userId ?? '';
  }

  toMap() {
    return {
      newarcHomeId: this.newarcHomeId,
      userId: this.userId,

    };
  }


  
}
